import { resolveKakaoTemplateId } from '@/shared/lib'

/**
 * 카카오 공유 카드 템플릿 ID (dev / stage·운영 분기)
 * - dev만 133880, stage·운영은 134134를 사용한다.
 * - car-story·모두의 차고가 공유 카드에 함께 사용한다.
 */
export const CAR_STORY_KAKAO_TEMPLATE_ID = resolveKakaoTemplateId({
  DEV: 133880,
  PROD: 134134,
})
